import React from 'react';
import { useSelector } from 'react-redux';
import './style.css';

const WaterMark = ({ slideId, watermarkData = {} }) => {
    const user = useSelector((state) => state.slide.userInformation);
    const {
        location = { lat: 'N/A', lng: 'N/A' },
        ip = 'N/A',
        currentDateTime = 'N/A'
    } = watermarkData || {};

    return (
        <div className="watermark-style" key={slideId}>
            <div>User: {user?.name || 'N/A'}</div>
            <div>Location: {location.lat}, {location.lng}</div>
            <div>IP: {ip}</div>
            <div>Time: {currentDateTime}</div>
        </div>
    );
};

export default React.memo(WaterMark);